import React from "react";
import PropTypes from "prop-types";

import Legend, { LegendItem } from "shared/react_components/Legend";

import { agentLegend, callerLegend } from "./styles/transcript.module.scss";

const TranscriptLegend = ({ className }) => (
  <Legend className={className}>
    <LegendItem className={callerLegend}>Caller</LegendItem>
    <LegendItem className={agentLegend}>Agent</LegendItem>
  </Legend>
);

TranscriptLegend.propTypes = {
  className: PropTypes.string
};

TranscriptLegend.defaultProps = {
  className: ""
};

export default TranscriptLegend;
